"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// 添加一个div到body上
var genContainerInBody = function genContainerInBody(id) {
  var body = document.getElementsByTagName('body')[0];
  var div = document.createElement('div');
  div.className = 'spaui-decorate';
  div.id = id;
  body.appendChild(div);
  return div;
}; // 用于变更组件参数的容器


var DecorateContainer = /*#__PURE__*/function (_PureComponent) {
  _inherits(DecorateContainer, _PureComponent);

  var _super = _createSuper(DecorateContainer);

  function DecorateContainer(props) {
    var _this;

    _classCallCheck(this, DecorateContainer);

    _this = _super.call(this, props);
    _this.state = {
      _decorate_show_component: false // 是否展示组件

    };
    return _this;
  }

  _createClass(DecorateContainer, [{
    key: "render",
    value: function render() {
      var Component = this.props.Component;

      var _this$state$_decorate = this.state._decorate_show_component,
          _decorate_show_component = _this$state$_decorate === void 0 ? true : _this$state$_decorate;

      var result = null;

      if (_decorate_show_component && typeof Component !== 'undefined' && Component) {
        result = /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.state, {
          _decorate_show_component: ""
        }));
      }

      return result;
    }
  }]);

  return DecorateContainer;
}(_react.PureComponent); // 计数id


var idCount = 0;

var Decorate = /*#__PURE__*/function () {
  function Decorate() {
    var _this2 = this;

    var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Decorate);

    this.Component = Component;
    this.id = "spaui-decorate-".concat(idCount++);
    this.timeout = null; // 如果有指定container就用对应的的结构

    this.componentContainer = container || genContainerInBody(this.id); // 初始化的时候就加上对应的结构

    this.instance = (0, _reactDom.render)( /*#__PURE__*/_react["default"].createElement(DecorateContainer, {
      Component: Component,
      ref: function ref(el) {
        return _this2.container = el;
      }
    }), this.componentContainer);
  }

  _createClass(Decorate, [{
    key: "setProps",
    value: function setProps() {
      var _this3 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      var triggerContainterChange = function triggerContainterChange() {
        // 如果已经声明好了，就重新设置下state
        if (_this3.container) {
          _this3.container.setState(_objectSpread({
            _decorate_show_component: true
          }, props), callback);
        }
      };

      if (this.container) {
        triggerContainterChange();
      } else {
        // 有可能一声明就直接调用了，但是this.instance还没有声明好，所以这里稍微延迟下
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          triggerContainterChange();
        }, 50);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this4 = this;

      var Component = this.Component || null; // 清空容器与结构

      var clearContainer = function clearContainer() {
        var $id = document.getElementById(_this4.id); // 组件清空

        if (_this4.container) {
          _this4.container.setState({
            _decorate_show_component: false
          });

          _this4.container = null;
          _this4.instance = null;

          if (typeof _reactDom.unmountComponentAtNode !== 'undefined') {
            (0, _reactDom.unmountComponentAtNode)(_this4.componentContainer);
          }

          _this4.componentContainer = null;
        } // 组件结构清空


        if ($id && $id.parentNode) {
          $id.parentNode.removeChild($id);
        }
      }; // 根据对应组件特殊处理下


      if (Component && Component.componentName && Component.componentName.indexOf('spaui-dialog') > -1) {
        this.setProps({
          show: false
        }, function () {
          clearContainer();
        });
      } else {
        clearContainer();
      }
    }
  }, {
    key: "destory",
    value: function destory() {
      this.destroy();
    }
  }]);

  return Decorate;
}();

var _default = Decorate;
exports["default"] = _default;